module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Vossloh Planner","short_name":"Vossloh","start_url":"/offline","background_color":"#33AE67","theme_color":"#33AE67","display":"standalone","icon":"public/static/img/logos/logo-256x256.png","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"1849d7f0a35651420eb90dd41ff26280"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
